import { getMonetixBanks, getMonetixCards, tokenizeMonetixCard } from "@actions/withdraw";
import FormItem from "@components/formItem";
import PaymentSelect from "@components/paymentSelect/index.jsx";
import { StakeFieldWrapper } from "@pages/profile-v2/pages/deposit/baseItems";
import { BoxWrapper } from "@pages/profile/withdraw/baseItems";
import { getUser } from "@utils";
import React, { Fragment } from "react";
import MaskInput from "react-maskinput";

import {
	Box,
	BoxTitle,
	Content,
	ContentTitle,
	ErrorInputWrapper,
	MaskedInput,
	MaskedInputLabel,
	StakeInput,
	StakeInputError,
} from "../baseItems";
import Base from "./base";

export default class Monetix extends Base {
	componentDidMount() {
		super.componentDidMount();
		getMonetixCards().then((res) => {
			this.setState({ cards: res.data.message });
		});
	}
	componentDidUpdate() {
		const { selectedCurrency, banks } = this.state;
		if (selectedCurrency && !banks) {
			const { method } = this.props;
			const methodType = method.split("Monetix")[1]?.toLowerCase();
			if (
				methodType === "columbia" ||
				methodType === "argentina" ||
				methodType === "chile" ||
				methodType === "thailandbank" ||
				methodType === "spei"
			) {
				getMonetixBanks({
					method: methodType === "thailandbank" ? "thailand" : methodType,
					currency: selectedCurrency,
					amount: 10, //bunasil olacak
				}).then((res) => {
					this.setState({ banks: res.data.message });
				});
			}
		}
	}

	tokenize(card) {
		const { cards } = this.state;
		const selectedCard = cards.find((item) => item.card_number === card);
		tokenizeMonetixCard({ ...selectedCard }).then((res) => {
			console.log(res);
		});
	}

	onSelectCard(e) {
		this.setState(
			{
				card: e.value,
			},
			() => {
				this.tokenize(e.value);
				this.checkRequiredFields(false);
			}
		);
	}

	onSelectBankId(e) {
		this.setState(
			{
				bank_id: e.value,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	onSelectBankCode(e) {
		this.setState(
			{
				bank_code: e.value,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	onSelectDocType(e) {
		this.setState(
			{
				doc_type: e.value,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	onSelectAccountType(e) {
		this.setState(
			{
				account_type: e.value,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	onSelectCryptoCurrency(e) {
		this.setState(
			{
				crypto_currency: e.value,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	onSelectCryptoPayway(e) {
		this.setState(
			{
				crypto_payway: e.value,
			},
			() => {
				this.checkRequiredFields(false);
			}
		);
	}

	handleFocus = (field) => {
		this.setState({ [field]: true });
	};

	handleBlur = (field, value) => {
		const cleanedValue = value.replace(/_/g, "").trim();
		const isEmptyOrMasked = cleanedValue === "";
		this.setState(
			{
				[field]: false,
				[`${field.replace("is", "").toLowerCase()}Value`]: isEmptyOrMasked
					? ""
					: cleanedValue,
			},
			this.checkRequiredFields
		);
	};

	onEnterValue = (field, e) => {
		const value = e.target.value.replace(/_/g, "");

		if (field === "doc_number") {
			const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 18);
			const isValid = alphanumericValue.length >= 11 && alphanumericValue.length <= 18;

			this.setState(
				{
					[field]: alphanumericValue,
					[`${field}Value`]: alphanumericValue,
					docNumberValid: isValid,
					docNumberError: !isValid
						? this.translate("DOC_NUMBER_MIN_AND_MAX_LENGTH_ERROR")
						: null,
				},
				this.checkRequiredFields
			);

			return;
		}

		if (field === "customer_city" || field === "customer_zip") {
			this.setState({ [field]: value, [`${field}Value`]: value }, this.checkRequiredFields);
			return;
		}

		const trimmedValue = value.trim();
		this.setState(
			{ [field]: trimmedValue, [`${field}Value`]: trimmedValue },
			this.checkRequiredFields
		);
	};

	checkRequiredFields = () => {
		const baseIsValid = super.checkRequiredFields ? super.checkRequiredFields() : true;

		const { method } = this.props;
		const { stake, selectedCurrency, doc_number, docNumberValid } = this.state;

		let isValid = baseIsValid && !!stake && !!selectedCurrency;

		if (method === "MonetixNequi" || method === "MonetixSpei") {
			if (doc_number) {
				isValid = isValid && docNumberValid === true;
			} else {
				isValid = false;
			}
		}

		if (this.state.canForward !== isValid) {
			this.setState({
				isValid,
				canForward: isValid,
			});
		}

		return isValid;
	};

	getStep1(translate) {
		const { method } = this.props;
		const {
			crypto_currency,
			crypto_payway,
			doc_type,
			banks,
			cards,
			bank_id,
			bank_code,
			account_type,
			card,
			isWalletMaskVisible,
			account,
			accountValue,
			customer_zip,
			customer_city,
			card_number,
		} = this.state;

		const onEnterDocNumber = (e) => {
			const value = e.target.value.replace(/_/g, "").trim();
			const alphanumericValue = value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 18);
			const isValid = alphanumericValue.length >= 11 && alphanumericValue.length <= 18;

			this.setState(
				{
					doc_number: alphanumericValue,
					doc_numberValue: alphanumericValue,
					docNumberValid: isValid,
					docNumberError: !isValid
						? translate("DOC_NUMBER_MIN_AND_MAX_LENGTH_ERROR")
						: null,
				},
				this.checkRequiredFields
			);
		};

		return (
			<Content>
				<ContentTitle>{translate("Payment_Stake")}</ContentTitle>
				<BoxWrapper>
					{this.getCurrencyField(translate)}
					<StakeFieldWrapper>
						<div className="stake-field">{this.getStakeField()}</div>
						<div className="min-max-field">{this.renderMinMax()}</div>
					</StakeFieldWrapper>
				</BoxWrapper>
				<Fragment>
					{method === "MonetixCard" && (
						<FormItem onRegister={() => this.registerField({ name: "card" })}>
							<Box>
								<BoxTitle>{translate("CARD")}</BoxTitle>
								<PaymentSelect
									value={card}
									options={(cards || []).map((item) => ({
										value: item.card_number,
										label: item.card_number,
									}))}
									handleSelect={this.onSelectCard.bind(this)}
								/>
							</Box>
						</FormItem>
					)}
					{method === "MonetixPix" && (
						<FormItem onRegister={() => this.registerField({ name: "pixkey" })}>
							<Box>
								<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
								<StakeInput
									placeholder="...................."
									type="number"
									onChange={this.onEnterValue.bind(this, "pixkey")}
								/>
							</Box>
						</FormItem>
					)}
					{(method === "MonetixBankTransfer" ||
						method === "MonetixSpei" ||
						method === "MonetixThailandBank") && (
						<FormItem onRegister={() => this.registerField({ name: "bank_id" })}>
							<Box>
								<BoxTitle>{translate("SELECT_BANK")}</BoxTitle>
								<PaymentSelect
									value={bank_id}
									options={(banks || []).map((item) => ({
										value: item.id,
										label: item.nativeName,
									}))}
									handleSelect={this.onSelectBankId.bind(this)}
								/>
							</Box>
						</FormItem>
					)}
					{method === "MonetixChileBankTransfer" && (
						<FormItem onRegister={() => this.registerField({ name: "bank_code" })}>
							<Box>
								<BoxTitle>{translate("SELECT_BANK")}</BoxTitle>
								<PaymentSelect
									value={bank_code}
									options={(banks || []).map((item) => ({
										value: item.id,
										label: item.name,
									}))}
									handleSelect={this.onSelectBankCode.bind(this)}
								/>
							</Box>
						</FormItem>
					)}
					{method === "MonetixNequi" ||
						(method === "MonetixSpei" && (
							<FormItem onRegister={() => this.registerField({ name: "doc_number" })}>
								<Box hasError={this.state.docNumberError}>
									<BoxTitle>{translate("DOC_NUMBER")}</BoxTitle>
									<ErrorInputWrapper>
										<StakeInput
											placeholder=".................."
											type="text"
											value={this.state.doc_number || ""}
											onChange={onEnterDocNumber}
											hasError={this.state.docNumberError}
										/>
										{this.state.docNumberError && (
											<StakeInputError>
												{this.state.docNumberError}
											</StakeInputError>
										)}
									</ErrorInputWrapper>
								</Box>
							</FormItem>
						))}
					{method === "MonetixSpei" && (
						<>
							<FormItem onRegister={() => this.registerField({ name: "doc_type" })}>
								<Box>
									<BoxTitle>{translate("SELECT_DOC_TYPE")}</BoxTitle>
									<PaymentSelect
										value={doc_type}
										options={[
											{ value: 0, label: translate("PLEASE_SELECT") },
											{ value: "RFC", label: "RFC" },
											{ value: "CURP", label: "CURP" },
										]}
										handleSelect={this.onSelectDocType.bind(this)}
									/>
								</Box>
							</FormItem>
							<FormItem
								onRegister={() => this.registerField({ name: "account_number" })}>
								<Box>
									<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
									<StakeInput
										type="text"
										onChange={this.onEnterValue.bind(this, "account_number")}
									/>
								</Box>
							</FormItem>

							<FormItem
								onRegister={() => this.registerField({ name: "account_type" })}>
								<Box>
									<BoxTitle>{translate("ACCOUNT_TYPE")}</BoxTitle>
									<StakeInput
										type="text"
										onChange={this.onEnterValue.bind(this, "account_type")}
									/>
								</Box>
							</FormItem>
						</>
					)}
					{method === "MonetixThailandBank" && (
						<FormItem onRegister={() => this.registerField({ name: "customer_name" })}>
							<Box>
								<BoxTitle>{translate("CUSTOMER_NAME")}</BoxTitle>
								<StakeInput
									placeholder="...................."
									onChange={this.onEnterValue.bind(this, "customer_name")}
								/>
							</Box>
						</FormItem>
					)}
					{(method === "MonetixBinancePay" || method === "MonetixThailandBank") && (
						<FormItem onRegister={() => this.registerField({ name: "account_number" })}>
							<Box>
								<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
								<StakeInput
									placeholder="...................."
									type="number"
									onChange={this.onEnterValue.bind(this, "account_number")}
								/>
							</Box>
						</FormItem>
					)}
					{method === "MonetixArgentinaBankTransfer" && (
						<FormItem onRegister={() => this.registerField({ name: "account_type" })}>
							<Box>
								<BoxTitle>{translate("SELECT_ACCCOUNT_TYPE")}</BoxTitle>
								<PaymentSelect
									value={account_type}
									options={[
										{ value: 0, label: translate("PLEASE_SELECT") },
										{ value: "CACC", label: "CACC" },
										{ value: "SVGS", label: "SVGS" },
									]}
									handleSelect={this.onSelectAccountType.bind(this)}
								/>
							</Box>
							<FormItem
								onRegister={() => this.registerField({ name: "account_number" })}>
								<Box>
									<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
									<StakeInput
										placeholder="...................."
										type="number"
										onChange={this.onEnterValue.bind(this, "account_number")}
									/>
								</Box>
							</FormItem>
							<FormItem onRegister={() => this.registerField({ name: "doc_type" })}>
								<Box>
									<BoxTitle>{translate("SELECT_DOC")}</BoxTitle>
									<PaymentSelect
										value={doc_type}
										options={[
											{ value: 0, label: translate("PLEASE_SELECT") },
											{ value: "CUIT", label: "CUIT" },
											{ value: "CUIL", label: "CUIL" },
										]}
										handleSelect={this.onSelectDocType.bind(this)}
									/>
								</Box>
							</FormItem>
							<FormItem onRegister={() => this.registerField({ name: "doc_number" })}>
								<Box>
									<BoxTitle>{translate("DOC_NUMBER")}</BoxTitle>
									<StakeInput
										placeholder="...................."
										type="number"
										onChange={this.onEnterValue.bind(this, "doc_number")}
									/>
								</Box>
							</FormItem>
						</FormItem>
					)}
					{method === "MonetixCrypto" && (
						<Fragment>
							<BoxWrapper>
								<FormItem
									onRegister={() =>
										this.registerField({ name: "crypto_currency" })
									}>
									<Box>
										<BoxTitle>{translate("Select_Crypto_Currency")}</BoxTitle>
										<PaymentSelect
											value={crypto_currency}
											options={[
												{ value: 0, label: translate("PLEASE_SELECT") },
												{ value: "USDT", label: "USDT" },
											]}
											handleSelect={this.onSelectCryptoCurrency.bind(this)}
										/>
									</Box>
								</FormItem>
								<FormItem
									onRegister={() => this.registerField({ name: "account" })}>
									<Box>
										<MaskedInput>
											<MaskInput
												ref={this.walletInputRef}
												onFocus={() =>
													this.handleFocus("isWalletMaskVisible")
												}
												onBlur={(e) =>
													this.handleBlur(
														"isWalletMaskVisible",
														e.target.value
													)
												}
												maskChar={isWalletMaskVisible ? "_" : ""}
												mask="******************************************"
												size={42}
												alwaysShowMask={window.IS_MARS ? true : false}
												onChange={(e) => this.onEnterValue("account", e)}
												value={isWalletMaskVisible ? account : accountValue}
											/>
											<MaskedInputLabel
												isFocused={isWalletMaskVisible}
												hasValue={accountValue}>
												{translate("WALLET_ADDRESS")}
											</MaskedInputLabel>
										</MaskedInput>
									</Box>
								</FormItem>
							</BoxWrapper>
							<FormItem
								onRegister={() => this.registerField({ name: "crypto_payway" })}>
								<Box>
									<BoxTitle>{translate("SELECT_CRYPTO_PAYWAY")}</BoxTitle>
									<PaymentSelect
										value={crypto_payway}
										options={[
											{ value: 0, label: translate("PLEASE_SELECT") },
											{ value: "TRC20", label: "TRC20" },
											{ value: "ERC20", label: "ERC20" },
										]}
										handleSelect={this.onSelectCryptoPayway.bind(this)}
									/>
								</Box>
							</FormItem>
						</Fragment>
					)}
					{method === "MonetixColumbiaBankTransfer" && (
						<Fragment>
							<FormItem
								onRegister={() => this.registerField({ name: "account_number" })}>
								<Box>
									<BoxTitle>{translate("ACCOUNT_NUMBER")}</BoxTitle>
									<StakeInput
										placeholder="...................."
										type="number"
										onChange={this.onEnterValue.bind(this, "account_number")}
									/>
								</Box>
							</FormItem>
							<FormItem onRegister={() => this.registerField({ name: "doc_type" })}>
								<Box>
									<BoxTitle>{translate("SELECT_DOC")}</BoxTitle>
									<PaymentSelect
										value={doc_type}
										options={[
											{ value: 0, label: translate("PLEASE_SELECT") },
											{ value: "CC", label: "CC" },
											{ value: "NIT", label: "NIT" },
										]}
										handleSelect={this.onSelectDocType.bind(this)}
									/>
								</Box>
							</FormItem>
							<FormItem onRegister={() => this.registerField({ name: "doc_number" })}>
								<Box>
									<BoxTitle>{translate("DOC_NUMBER")}</BoxTitle>
									<StakeInput
										placeholder="...................."
										type="number"
										onChange={this.onEnterValue.bind(this, "doc_number")}
									/>
								</Box>
							</FormItem>
						</Fragment>
					)}
					{(method === "MonetixSepa" || method === "MonetixFasterPayments") && (
						<Fragment>
							<FormItem
								onRegister={() => this.registerField({ name: "customer_zip" })}>
								<Box>
									<BoxTitle>{translate("CUSTOMER_ZIP")}</BoxTitle>
									<StakeInput
										placeholder="...................."
										type="text"
										onChange={this.onEnterValue.bind(this, "customer_zip")}
										value={customer_zip || ""}
									/>
								</Box>
							</FormItem>
							<FormItem
								onRegister={() => this.registerField({ name: "customer_city" })}>
								<Box>
									<BoxTitle>{translate("CUSTOMER_CITY")}</BoxTitle>
									<StakeInput
										placeholder="...................."
										type="text"
										onChange={this.onEnterValue.bind(this, "customer_city")}
										value={customer_city || ""}
									/>
								</Box>
							</FormItem>
						</Fragment>
					)}

					{method === "MonetixCardOut" && (
						<Fragment>
							<FormItem
								onRegister={() => this.registerField({ name: "card_number" })}>
								<Box>
									<BoxTitle>{translate("CARD_NUMBER")}</BoxTitle>
									<StakeInput
										placeholder="...................."
										type="text"
										onChange={this.onEnterValue.bind(this, "card_number")}
										value={card_number || ""}
									/>
								</Box>
							</FormItem>
						</Fragment>
					)}
				</Fragment>
			</Content>
		);
	}

	makeExternalPayment() {
		const { method } = this.props;
		const {
			stake,
			pixkey,
			account_number,
			selectedCurrency,
			crypto_currency,
			doc_number,
			crypto_payway,
			doc_type,
			banks,
			customer_name,
			bank_id,
			bank_code,
			account_type,
			card_number,
			customer_zip,
			customer_city,
		} = this.state;
		let withdrawData = {
			method: method.split("Monetix")[1],
			pixkey,
			type: "Monetix",
			account_number,
			crypto_currency,
			customer_name,
			doc_number,
			crypto_payway,
			doc_type,
			bank_name: bank_id ? banks.find((item) => item.id === bank_id)?.name : "",
			bank_id,
			bank_code,
			account_type,
			username: getUser().username,
			sessionId: getUser().sessionId,
			amount: {
				value: Number(stake),
				currency: selectedCurrency,
			},
			language: this.getActiveLanguageCode(),
			note: new Date(),
			wallet_address: this.state.account,
			card_number,
			customer_zip,
			customer_city,
		};
		this.props.onWithdraw(withdrawData, () => {
			this.onBackToWithdrawPage();
		});
	}
}
